import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../store/auth';

function AuthGuard({ element }: { element?: React.ReactNode | React.ComponentType }) {
  const { isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      navigate('/login');
    }
  }, [isAuthenticated]);

  if (isLoading || !isAuthenticated) {
    return <></>;
  }

  const Element: React.ComponentType = element as React.ComponentType;

  return <>{element && typeof element === 'function' ? <Element /> : element}</>;
}

export { AuthGuard };
